"use client";

import React from "react";
import { HiChevronDoubleRight } from "react-icons/hi"; 
import AnimatedCount from "@/app/components/ui/common/CountUp/AnimatedCount";

export const dynamic = "force-dynamic";

const BusinessEnterprise = () => {
    const careerData = [
        {
            Title: "Flexible hiring models:",
            subData:
                " Depending on their needs for their businesses, we give our clients the freedom to select either a dedicated team model or a fixed pricing model.",
        },
        {
            Title: "Agile methodology:",
            subData:
                " We use the agile methodology, which makes it simple for clients and developers to manage the business software development process.",
        },
        {
            Title: "Collaborative approach:",
            subData:
                " Our collaborative approach ensures that we support our clients at every stage, from planning, design and development to post-launch service.",
        },
        {
            Title: "Robust architecture:",
            subData:
                " UI/UX and a solid architectural design are just two components of an enterprise software application that is compelling. Our team maintains a practical mindset and creates sturdy architecture that integrates into a business for a longer period of time. Learn how to increase the ROI of your business app.",
        },
    ];

    const counterData = [
        {
            id: 1,
            title: 495,
            description: "Number of processes simplified",
            suffix: "+",
        },
        {
            id: 2,
            title: 17438,
            description: "Number of Work-Hours Made Productive",
            suffix: "+",
        },
        {
            id: 3,
            title: 453,
            description: "Number of Businesses Streamlined",
            suffix: "+",
        },
    ];

  const counterList = counterData?.map((item, ind) => {
        return (
            <div className="" key={item?.id || ind}>
                <h2
                    id="counter"
                    className="text-4xl text-[#410EAD] leading-loose font-bold font-manrope"
                > 
                    <AnimatedCount end={item?.title} suffix={item?.suffix} />
                </h2>
                <h3 className="text-2xl font-manrope leading-9 text-[#404040]">
                    {item?.description}
                </h3>
            </div>
        );
    });

    return (
      <>
        <div className="container mx-auto  md:gap-5  gap-1 font-bold  px-4 md:px-24 lg:px-24 xl:px-0 md:mt-[140px] pt-10">
          <h2 className=" md:text-4xl text-xl font-bold font-manrope text-center">
            Why Innovate Your Enterprise
            <span className="text-[#410EAD] lg:block font-manrope ">Business with Tan θ?</span>
          </h2>
          {careerData?.map((ele, index) => (
            <div className="" key={index}>
              <p className="flex font-bold text-[20px]  gap-5  xl:px-40 pt-10 text-[#410EAD]">
                <HiChevronDoubleRight />
                {ele?.Title}
              </p>
              <p className="xl:px-40 text-[#59587B]  font-normal leading-4 md:pt-2 pt-5">{ele?.subData}</p>
            </div>
          ))}
        </div>
        <div className="container mx-auto pt-10  md:px-24">
          <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 items-center text-center font-bold">
            {counterList}
          </div>
        </div>
      </>
    );
};

export default BusinessEnterprise; 